import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useDialogs } from '@work4all/components';

import { useApiLicenseLock } from '../hooks/use-api-license-lock';

export function useLicenseLockAlert() {
  const { locked: apiLicenseLock, current, max } = useApiLicenseLock();
  const { t } = useTranslation();
  const dialogs = useDialogs();

  const dialogWasOpened = useRef(false);
  useEffect(() => {
    if (apiLicenseLock && !dialogWasOpened.current) {
      dialogWasOpened.current = true;
      dialogs.alert({
        title: t('MASK.WARNING'),
        description: t('ALERTS.LICENSE.LOCK', { calculated: current - max }),
      });
    }
  }, [apiLicenseLock, current, dialogs, max, t]);
}
